import "core-js/modules/es6.string.trim";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.replace";

/* eslint-disable no-param-reassign */
export default (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      remove = _ref.remove,
      _ref$fn = _ref.fn,
      _fn = _ref$fn === void 0 ? 'require' : _ref$fn,
      _ref$imports = _ref.imports,
      _imports = _ref$imports === void 0 ? [] : _ref$imports;

  var num = 0;

  var getIdentifier = function getIdentifier(src) {
    return "".concat(src.split('/').pop().replace(/\W/g, '_'), "$").concat(num++);
  };

  return {
    visitor: {
      Program: {
        leave: function leave() {
          if (_imports.length && remove) this.trimLines();
        }
      },
      ImportDeclaration: function ImportDeclaration(node) {
        if (!node.source) return;
        var value = node.source.value,
            start = node.start,
            end = node.end;
        var details = {
          base: null,
          source: value,
          keys: [],
          code: ''
        };
        var named = [];
        var req = "".concat(_fn, "('").concat(value, "');");
        var tmp = getIdentifier(value);
        node.specifiers.forEach(function (_ref2) {
          var type = _ref2.type,
              local = _ref2.local,
              imported = _ref2.imported;

          if (type === 'ImportSpecifier') {
            var key = {
              local: local.name,
              imported: imported.name
            };
            details.keys.push(key);
            named.push(key.local === key.imported ? key.local : "".concat(key.imported, ": ").concat(key.local));
          } else {
            details.base = local.name;
            details.code += "const ".concat(tmp, " = ").concat(req, "\nconst ").concat(local.name, " = ").concat(tmp, ".default || ").concat(tmp, ";\n");
          }
        });

        if (named.length) {
          details.code += "const { ".concat(named.join(', '), " } = ").concat(details.code ? "".concat(tmp, ";") : req);
        }

        details.code = details.code.trim() || req;

        _imports.push(details);

        if (remove) {
          this.remove(start, end);
          return;
        }

        this.overwrite(start, end, details.code);
      }
    }
  };
});